module.exports = __webpack_public_path__ + "static/media/bonito-ms.71dcebad.jpg";